const content = {
    heading1:`The key to a secure data - safe from data breaches`,
    heading2:`What Do We Do Differently?`,
}


export {content};